/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text, BrandColors } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';

import { getReplyByNameAndTime } from '../../utils/threadUtils';
import { AttachmentRepeater } from '../../containers/NewThreadModal/AttachmentRepeater';
import { useContext } from 'react';
import { InboxContext } from '../../containers/Inbox/InboxContext';

const styles = StyleSheet.create({
  attachmentRepeaterWrapper: {
    marginTop: 20,
  },
  bodyWrapper: {
    paddingTop: 14,
    whiteSpace: 'pre-wrap',
  },
  messageWrapper: {
    ':hover': {
      boxShadow: `0 5px 5px 0px ${BrandColors.BOX_SHADOW}`,
      position: 'relative',
    },
    backgroundColor: BrandColors.WHITE,
    border: `1px solid ${BrandColors.CLOUD_50}`,
    overflow: 'hidden',
    padding: '14px 24px 14px 24px',
    transition: '0.2s',
  },
  replyNameAndTimeWrapper: {
    borderBottom: `1px solid ${BrandColors.CLOUD_50}`,
    paddingBottom: 14,
  },
});

export namespace Message {
  export interface Props {
    message: BlendBridge.API.ThreadMessage;
  }
}

export const Message: React.FC<Message.Props> = ({ message }) => {
  const {
    stylingConfig: { singleItemPerRow },
  } = useContext(InboxContext);
  const renderMessengeReplyByNameAndTime = () => {
    const {
      createdAt,
      from: { entityType, entityUser },
    } = message;

    const replyBy = {
      createdAt,
      entityType,
      entityUser,
    };

    return (
      <div className={css(styles.replyNameAndTimeWrapper)}>
        <Text colorName="NIGHT_80" fontSize="sm">
          {getReplyByNameAndTime(replyBy)}
        </Text>
      </div>
    );
  };

  return (
    <div className={css(styles.messageWrapper)}>
      {renderMessengeReplyByNameAndTime()}
      <div className={css(styles.bodyWrapper)}>
        <Text colorName="NIGHT" fontSize="md">
          {message.body}
        </Text>

        {message.attachments.length > 0 && (
          <div className={css(styles.attachmentRepeaterWrapper)}>
            <AttachmentRepeater
              attachments={message.attachments}
              disableRemoveOption
              singleItemPerRow={singleItemPerRow}
            />
          </div>
        )}
      </div>
    </div>
  );
};
